module.exports = __webpack_public_path__ + "static/img/029.f66012f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/029.png
// module id = YVL5
// module chunks = 1